<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="mobileVersion ? 'fs' : 'lg-fix-h'">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{processMessage}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 overflow-x-auto"
        :style="mobileVersion ? 'height: 80vh;' : 'height: 60vh;'">
        <el-form ref="ruleForm" class="h-full" :model="form" :rules="rules">
          <div class="w-full">
            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('invoices.recurrence_name') }}</label>
            <el-form-item prop="recurrenceName">
              <el-input clearable class="w-full" v-model="form.recurrenceName" />
            </el-form-item>
          </div>
          <div class="lg:mb-2">
            <div ref="selectPGERef">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('invoices.recurrence_period') }}</label>
              <el-form-item prop="recurrenceType">
                <base-el-select class="w-full" :options="tiposPeriodo" v-model="form.recurrenceType" clearable />
              </el-form-item>
            </div>
          </div>
          <div class="flex flex-row items-center gap-4">
            <div class="mb-6">
              <span class="text-sm font-semibold text-secondary-600 block mb-1"></span>
              <el-switch class="switch-text break-normal min-h-16" v-model="form.adjustMonthDate" :active-text="$t('invoices.adjust_month')" :disabled="loading"></el-switch>
            </div>
            <div v-if="form.adjustMonthDate">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.days_before_month') }}</label>
              <el-form-item prop="adjustDays">
                <base-el-select class="w-full" :options="adjustDaysRange" v-model="form.adjustDays" filterable :disabled="loading" />
              </el-form-item>
            </div>
          </div>
          <div class="w-full mb-2">
            <el-form-item prop="endRecurrenceDate" class="mb-2">
              <div class="flex flex-row items-center mb-1">
                <label class="text-sm font-semibold text-secondary-600 block">{{ $t('invoices.recurrence_date') }}</label>
                <base-tooltip-icon v-if="suggestedRecurrenceDate !== null" size="sm" :content="$t('invoices.dialogs.suggested_recurrence', {date: $d(suggestedRecurrenceDate, 'short_date')})" placement="top" class="ml-1"/>
              </div>
              <el-date-picker v-model="form.endRecurrenceDate" type="date" :picker-options="dateRangeOptions"
                popper-class="!z-[2020]" :format="datePattern" :default-value="defaultSuggestedDate" value-format="yyyy-MM-dd[T00:00:00]" :disabled="loading" />
            </el-form-item>
          </div>
          <div class="w-full mb-2 mt-6">
            <span
              class="text-sm font-semibold text-secondary-600 block mb-1"></span>
            <el-switch class="switch-text break-normal" v-model="form.sendAuto" :active-text="$t('app.send_auto')" :disabled="loading"></el-switch>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <div class="flex flex-row w-full justify-between">
        <base-button class="w-full mx-2" mode="secondary-phantom-blue" :text="$t('app.cancel')" :loading="loading" @click="toggleDialog" />
        <base-button mode="secondary-phantom-blue" class="w-full mx-2" :loading="loading"
          :text="buttonMessagge" @click="applyHandler('ruleForm')" />
      </div>
    </template>
  </base-dialog-button>
</template>
<script>
import moment from 'moment'
import { i18n } from '@/i18n'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'
import { getFacturaRecurrenteDetalle } from '@/services/invoices/getFacturaRecurrenteDetalle'
import { crearFacturaRecurrente } from '@/services/invoices/crearFacturaRecurrente'
import { actualizarFacturaRecurrente } from '@/services/invoices/actualizarFacturaRecurrente'


export default {
  name: 'invoice-recurrence-dialog',
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    },
    editRecurrence: {
      type: Boolean,
      default: false
    },
    idFacturae: [Number, String],
    idInvoice: [Number, String],
    emmissionDate: [Date],
    idFacturaRecurrente: [Number, String]
  },
  data () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
        disabledDate: this.disabledDateOptions
      },
      loading: false,
      processMessage: '',
      buttonMessagge: '',
      suggestedRecurrenceDate: null,
      suggestedMessagge: '',
      isOpen: this.dialogOpen,
      files: [],
      form: this.getDefaultForm(),
      adjustDaysRange: ['0', '1', '2', '3', '4', '5'],
      rules: {
        recurrenceName: [{
          required: true,
          message: i18n.t('validation.complete'),
          trigger: ['blur', 'change'],
        }],
        recurrenceType: [{
          required: true,
          message: i18n.t('validation.complete'),
          trigger: ['blur', 'change'],
        }]
      },
    }
  },
  computed: {
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    tiposPeriodo: function () {
      return this.$store.getters['config/TIPOS_RECURRENCIA']
    },
    fileName: function () {
      if (this.files?.length) {
        return this.files[0].name
      }
      return ''
    },
    defaultSuggestedDate: function () {
      return this.suggestedRecurrenceDate ?? new Date()
    }
  },
  watch: {
    // Inicializar al abrir el componente
    dialogOpen: async function (value, oldValue) {
      if (value) {
        this.resetForm()
        this.buttonMessagge = this.editRecurrence ? i18n.t('tipos.accion.edit_recurrence') : i18n.t('tipos.accion.add_recurrence')
        this.processMessage = this.editRecurrence ? i18n.t('invoices.dialogs.edit_recurrence_header'): i18n.t('invoices.dialogs.add_recurrence_header')
        if (this.editRecurrence) {
          await this.setInvoice(this.idFacturaRecurrente)
        }
        this.getDateNextInvoice(this.emmissionDate, this.form.recurrenceType, this.form.adjustMonthDate, this.form.adjustDays)
      }
    },
    'form.recurrenceType': function (value, oldValue) {
      if (value && value !== oldValue) {
        this.getDateNextInvoice(this.emmissionDate, value, this.form.adjustMonthDate, this.form.adjustDays)
      }
    },
    'form.adjustMonthDate': function (value, oldValue) {
      if (value) {
        if (!this.form.adjustDays) {
          this.form.adjustDays = '0'
        } 
        if (value !== oldValue) {
          this.getDateNextInvoice(this.emmissionDate, this.form.recurrenceType, value, this.form.adjustDays)
        }
      }
    },
    'form.adjustDays': function (value, oldValue) {
      if (value && value !== oldValue) {
        this.getDateNextInvoice(this.emmissionDate, this.form.recurrenceType, this.form.adjustMonthDate, value)
      }
    },
  },
  methods: {
    disabledDateOptions: function (date) {
      return moment(date).isBefore(this.suggestedRecurrenceDate, 'day')
    },
    getDefaultForm: function () {
      return {
        recurrenceName: '',
        recurrenceType: '',
        endRecurrenceDate: '',
        adjustMonthDate: false,
        adjustDays: '',
        sendAuto: false
      }
    },
    resetForm: async function () {
      this.form = this.getDefaultForm()
    },
    setInvoice: async function (idFacturaRecurrente) {
      if (idFacturaRecurrente) {
        try {
          const response = await getFacturaRecurrenteDetalle({ IdFacturaRecurrente: idFacturaRecurrente })
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.form.recurrenceName = response.Respuesta.NobreRecurrencia || ''
            this.form.recurrenceType = response.Respuesta.IdPeriodo.toString() || ''
            this.form.endRecurrenceDate = response.Respuesta.fechaFinRecurrencia || ''
            this.form.adjustMonthDate = !!response.Respuesta.ajustarFinDeMes
            this.form.adjustDays = response.Respuesta.diasDeAjuste.toString() || ''
            this.form.sendAuto = !!response.Respuesta.AutoEnviar
          }
        } catch (error) {
          this.doFeedback()
        }
      }
    },
    toggleDialog: function () {
      if (!this.loading) {
        this.isOpen = !this.isOpen
        this.resetForm()
        this.$emit('toggleDialog')
      }
    },
    applyHandler: async function (formName) {
      if (this.editRecurrence) {
        await this.updateRecurrence(formName)
      } else {
        await this.newRecurrence(formName)
      }
    },
    newRecurrence: async function (formName) {
      if (!this.loading) {
        this.$refs[formName].validate(async (valid) => {
          try {
            if (valid) {
              this.loading = true
              const params = {
                IdFacturae: this.idFacturae || null,
                IdInvoice: this.idInvoice || null,
                NobreRecurrencia: this.form.recurrenceName || null,
                IdPeriodo: parseInt(this.form.recurrenceType) || null,
                fechaFinRecurrencia: this.form.endRecurrenceDate || null,
                ajustarFinDeMes: !!this.form.adjustMonthDate,
                diasDeAjuste: parseInt(this.form.adjustDays) || 0,
                AutoEnviar: !!this.form.sendAuto
              }
              const response = await crearFacturaRecurrente(params)
              if (response.blnError) {
                this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
              } else {
                this.doFeedback(i18n.t('feedback.success.entity_updated_msg'), 'success')
                this.$emit('applyDialog')
              }
            }
          } finally {
            this.loading = false
          }
        })
      }
    },
    updateRecurrence: async function (formName) {
      if (!this.loading) {
        this.$refs[formName].validate(async (valid) => {
          try {
            if (valid) {
              this.loading = true
              const payload = {
                IdFacturaRecurrente: this.idFacturaRecurrente || null,
                NobreRecurrencia: this.form.recurrenceName || null,
                IdPeriodo: parseInt(this.form.recurrenceType) || null,
                fechaFinRecurrencia: this.form.endRecurrenceDate || null,
                ajustarFinDeMes: !!this.form.adjustMonthDate,
                diasDeAjuste: parseInt(this.form.adjustDays) || 0,
                AutoEnviar: !!this.form.sendAuto
              }
              const response = await actualizarFacturaRecurrente(payload)
              if (response.blnError) {
                this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
              } else {
                this.doFeedback(i18n.t('feedback.success.entity_updated_msg'), 'success')
                this.$emit('applyDialog')
              }
            }
          } finally {
            this.loading = false
          }
        })
      }
    },
    getDateNextInvoice: function (emmissionDate, recurrenceType, adjustMonth = false, adjustDays = 0) {
      const today = new Date(moment().startOf('day'))
      this.suggestedRecurrenceDate = null
      let suggestedDate = null

      switch (parseInt(recurrenceType)) {
        case 1:
          suggestedDate = this.addMonths(1, emmissionDate)
          if (suggestedDate < today) {
            suggestedDate = this.addMonths(1, today)
          }
          break
        case 2:
          suggestedDate = this.addMonths(3, emmissionDate)
          if (suggestedDate < today) {
            suggestedDate = this.addMonths(3, today)
          }
          break
        case 3:
          suggestedDate = this.addMonths(6, emmissionDate)
          if (suggestedDate < today) {
            suggestedDate = this.addMonths(6, today)
          }
          break
        case 4:
          suggestedDate = this.addMonths(12, emmissionDate)
          if (suggestedDate < today) {
            suggestedDate = this.addMonths(12, today)
          }
          break
      }

      if (adjustMonth) {
        const suggestedDateYear = suggestedDate.getFullYear()
        const suggestedDateMonth = suggestedDate.getMonth()
        const lastDayInMonth = new Date(suggestedDateYear, suggestedDateMonth + 1, 0).getDate() - (parseInt(adjustDays) || 0)
        suggestedDate = new Date(suggestedDateYear, suggestedDateMonth, lastDayInMonth)
      }
      this.suggestedRecurrenceDate = suggestedDate || null
    },
    addMonths: function (months = 0, date = moment().toDate()) {
      const newDate = new Date(date)
      newDate.setMonth(newDate.getMonth()+ months)
      return newDate
    }
  },
}
</script>
<style scoped>
.el-date-editor {
  width: 100%;
}
.el-form-item:has(.el-upload)::v-deep .el-form-item__content {
  line-height: inherit;
}
#fileSelector::v-deep .el-upload:has(+ .is-disabled),
#fileSelector::v-deep .el-upload:has(+ .is-disabled) .el-upload-dragger {
  cursor: not-allowed;
}
</style>
